import { EnglishArabicDTO } from "bbsf-controls"
export class SMSTemplateInfoDTO
{
      ID:number
      SMS :EnglishArabicDTO=new EnglishArabicDTO();
      SmsEN :string
      SmsAR :string
      LanguageModeItemID:number
      LanguageModeItemName:string

}
     